<script setup lang="ts">
import { BaseSkeleton } from '@/shared/ui/BaseSkeleton';

const { logo, loading } = defineProps<{ logo: string; loading: boolean }>();
</script>

<template>
  <div class="affinity-logo-wrapper">
    <BaseSkeleton v-if="loading" :width="128" :height="36" />
    <img
      v-else
      class="affinity__logo"
      :src="`data:image/png;base64,${logo}`"
      alt="Affinity Logo"
    >
  </div>
</template>

<style scoped lang="scss">
@use '@styles/utils' as *;

.affinity {
  &-logo-wrapper {
    display: flex;
    justify-content: center;
    max-width: 128px;
    padding: 10px;
    border-radius: 14px;
    background: #fff;
    margin: var(--spacing-6) auto;
  }

  &__logo {
    width: 100%;
    height: auto;
  }
}
</style>
